const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

export default class VideoModal {

  // Constructor
  constructor() {

    this.videoTriggers = Array.prototype.slice.call(document.querySelectorAll('.js-video-play-btn'), 0)

    this.videoTriggerClickHandler = this.videoTriggerClickHandler.bind(this)

    this.videoTriggers.forEach((videoTrigger) => {
      videoTrigger.addEventListener('click', this.videoTriggerClickHandler)
    })

    this.popupOverlayCloseHandler = this.popupOverlayCloseHandler.bind(this)
    this.popupEscapeCloseHandler = this.popupEscapeCloseHandler.bind(this)

    document.addEventListener('keyup', this.popupEscapeCloseHandler)
  }

  videoTriggerClickHandler(e) {
    this.updateCurrentModel(e.currentTarget.dataset.videoModal)
    this.open()
  }

  updateCurrentModel(newModalId) {
    this.close()
    this.element = document.getElementById(newModalId)
  }

  open() {
    this.element.classList.add('show')
    disableBodyScroll(this.element)
    this.mediaElement = this.element.querySelector('mediaelementwrapper')
    this.element.focus()

    this.element.addEventListener('mousedown', this.popupOverlayCloseHandler)
  }

  close() {
    if (this.element) {
      this.element.classList.remove('show')
      enableBodyScroll(this.element)
      this.resetMedia()
      this.element.removeEventListener('mousedown', this.popupOverlayCloseHandler)
    }
  }

  popupEscapeCloseHandler(e) {
    if (e.keyCode === 27) {
      this.close()
    }
  }

  resetMedia() {
    if (this.mediaElement) {
      this.mediaElement.pause()
      this.mediaElement.setCurrentTime(0)
    }
  }

  // closeClickHandler(e) {
  //   this.close()
  // }

  // popupClickHandler(e) {
  //   e.stopPropagation();
  // }

  popupOverlayCloseHandler(e) {
    
    if (e.target.closest('.video-modal--popup')) {
      return;
    }

    this.close()
  }

  // // Public Methods
  // resize() {
  // }
}
